/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useEffect } from 'react';
import { SpecialSavings } from '@one-thd/sui-icons';
import { Typography } from '@one-thd/sui-atomic-components';
import { useMessage } from '../hooks/useMessage';
import { MESSAGE_KEY } from '../utils/constants';
import { usePromoModel } from '../hooks/usePromoModel';
import {
  setProductImpressionData,
  triggerNewRelicEvent
} from '../utils/utils';

export const PromoMessaging = () => {
  const promoMessage = useMessage(MESSAGE_KEY.plpMessage);
  const analyticsMessage = useMessage(MESSAGE_KEY.analyticsMessage);
  const { itemId, subExperience } = usePromoModel();

  useEffect(() => {
    if (analyticsMessage) {
      setProductImpressionData(itemId, {
        name: 'promo messaging',
        type: analyticsMessage
      });
    }

    triggerNewRelicEvent({
      actionName: (promoMessage
        ? 'PLP-Promo-Messaging' : 'PLP-Promo-Messaging-Not-Built'
      ),
      customAttributes: {
        segment: 'Promotion',
        subExperience,
        itemId,
        promoMessage
      }
    });
  });

  if (!promoMessage) {
    return null;
  }

  return (
    <div data-testid="promo-message">
      <div
        className={'sui-bg-success sui-p-[0.1rem] sui-flex sui-gap-2 '
          + 'sui-flex-row sui-rounded-md sui-max-w-[250px] sui-w-fit sui-pr-3 sui-pl-1'}
      >
        <div className="sui-flex sui-items-start sui-pl-[0.3rem] sui-mt-1 sui-mb-1">
          <SpecialSavings size="small" />
        </div>
        <div>
          <Typography
            align="left"
            component="span"
            data-testid="promo-primary-message"
            variant="body-xs"
            weight="bold"
          >
            {promoMessage}
          </Typography>
        </div>
      </div>
    </div>
  );
};